/* tslint:disable */
/* eslint-disable */
/**
 * Document API
 * API for managing documents
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the LineItem interface.
 */
export function instanceOfLineItem(value) {
    return true;
}
export function LineItemFromJSON(json) {
    return LineItemFromJSONTyped(json, false);
}
export function LineItemFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'item': json['item'] == null ? undefined : json['item'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'price': json['price'] == null ? undefined : json['price'],
        'productCode': json['productCode'] == null ? undefined : json['productCode'],
        'unit': json['unit'] == null ? undefined : json['unit'],
        'unitPrice': json['unitPrice'] == null ? undefined : json['unitPrice'],
        'description': json['description'] == null ? undefined : json['description'],
        'taxRate': json['taxRate'] == null ? undefined : json['taxRate'],
    };
}
export function LineItemToJSON(json) {
    return LineItemToJSONTyped(json, false);
}
export function LineItemToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'item': value['item'],
        'quantity': value['quantity'],
        'price': value['price'],
        'productCode': value['productCode'],
        'unit': value['unit'],
        'unitPrice': value['unitPrice'],
        'description': value['description'],
        'taxRate': value['taxRate'],
    };
}
